const metadataFieldNames = {
  siteId_autoAssignMonitoringFeature: 'auto-assign-monitoring-feature',
  siteId_shouldCreateNew: 'create-new-site-id',
  siteId_shouldDeleteDuringRollback: 'delete-site-id-during-rollback',
  mediaType_shouldCreateNew: 'create-new-mediatype',
  mediaType_shouldDeleteDuringRollback: 'delete-mediatype-during-rollback',
  analyte_shouldCreateNew: 'create-new-analyte',
  analyte_shouldDeleteDuringRollback: 'delete-analyte-during-rollback',
  depthStart_validateDataType: 'validate-data-type',
  depthDatumType_autoAssignDepthType: 'auto-assign-depth-datum-type',

}

export default metadataFieldNames
